import { toURL } from '~/utils/urlResolver'

import type { ImageProps } from '../Image/Image'
import { urlFor } from '../Image/Image'

export const infoWindowToString = (
  name: string,
  town?: string,
  city?: string,
  telephone?: string,
  image?: ImageProps,
  url?: {
    _type: string
    slug: string
  }
) => {
  const img = image
    ? `<a href="${toURL(url as any)}"><img src="${urlFor(
        image.asset,
        200
      )}" alt="${name}"/></a>`
    : ''

  const link = url ? `<a href="${toURL(url as any)}">View details</a>` : ''

  const address = town ? `${town}, ${city}` : city

  return `
    <div class="map-infowindow">
      ${img}
      <h5>${name}</h5>
      <p>${address}<br />
      Tel: ${telephone}</p>
      
      ${link}
    </div>
  `
}
